import { render } from "./SetNick.vue?vue&type=template&id=3bae5b6e&scoped=true"
import script from "./SetNick.vue?vue&type=script&lang=js"
export * from "./SetNick.vue?vue&type=script&lang=js"

import "./SetNick.vue?vue&type=style&index=0&id=3bae5b6e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bae5b6e"]])

export default __exports__